import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoadingThreeQuarters = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 22 22",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#F2F2F2",
		d: "M11 0a11 11 0 0 0-9.169 17.077l2.294-1.52A8.248 8.248 0 0 1 11 2.751z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M11 0A11 11 0 1 1 .538 7.6l2.617.851A8.248 8.248 0 1 0 11 2.751z"
	})]
});
export default SvgLoadingThreeQuarters;
